export default __webpack_public_path__ + "static/media/Theme2.fe7a41c9.jpg";